import { render } from "./ServiceSelection.vue?vue&type=template&id=552a4ae6"
import script from "./ServiceSelection.vue?vue&type=script&lang=js"
export * from "./ServiceSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__